import SendOutlinedIcon from '@mui/icons-material/SendOutlined'
import { useFirestoreID } from '../../firebase/useFirestore'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { client } from '../../hooks/Client'
import { buildShareQuestionnairePath } from '../../helpers/questionnaires/shareQuestionnairePath'

const PersonaResearchLink = ({researchID, personaID}) => {

    // State
    const [questionnaireID, setQuestionnaireID] = useState('')

     // Hooks
    const history = useHistory()

    // Firestore
    const researches = useFirestoreID('Research', researchID ? researchID : '0')

    // Set questionnaire ID
    useEffect(() => {
        researches && researches.map(research => {
            setQuestionnaireID(research.QuestionnaireID)
        })
    }, [researches, researchID])
 
  return (
    <SendOutlinedIcon className="table-delete-icon" onClick={() => history.push(buildShareQuestionnairePath({ client, questionnaireID, researchID, respondentID: personaID }))}/>
  )
}

export default PersonaResearchLink